import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/Layout.vue'

Vue.use(Router)

/**
 * constantRoutes
 *没有权限要求的基本页面
 *可以访问所有角色
 */
export const constantRouterMap = [
	{
	    path: '/login',
		meta: { title: '登录',icon:"s-tools" },
	    component: () => import('@/page/login/login'),
	},
	// {
	//     path: '/register',
	// 	meta: { title: '注册',icon:"s-tools" },
	//     component: () => import('@/page/login/register'),
	// },
	// {
	//     path: '/forgot',
	// 	meta: { title: '忘记密码',icon:"s-tools" },
	//     component: () => import('@/page/login/forgot'),
	// },
	{
	    path: '/',
	    component: Layout,
	    meta: { title: '主页',icon:"s-home" },
	    children: [
	        {path: '/',component: () => import('@/page/Dashboard'),meta: { title: '主页'}},
	    ]
	},
	

]
/**
 * asyncRoutes
 * 需要根据用户角色动态加载的路由
 * path必须为唯一否则其他管理员生成路由可能会有bug。
 */
export var asyncRoutes = [
	{
		title:'任务管理',
	    path: '/task/',
	    component: Layout,
	    meta: { title: '任务管理',icon:"present" },
	    children: [
	        // {title:'任务',path: 'list',component: () => import('@/page/task/list'),meta: { title: '任务'}},
			{title:'订单',path: 'order_list',component: () => import('@/page/task/order_list'),meta: { title: '订单'}},
			{title:'投诉列表',path: 'complain_list',component: () => import('@/page/task/complain_list'),meta: { title: '投诉列表'}},
	    ]
	},
	{
		title:'资金管理',
	    path: '/task/',
	    component: Layout,
	    meta: { title: '资金管理',icon:"money" },
	    children: [
			{title:'账户设置',path: 'account',component: () => import('@/page/user/account'),meta: { title: '账户设置'}},
			{title:'提现',path: 'withdrawal',component: () => import('@/page/user/withdrawal'),meta: { title: '提现'}},
			{title:'提现记录',path: 'withdrawal_list',component: () => import('@/page/user/withdrawal_list'),meta: { title: '提现记录'}},
			{title:'佣金记录',path: 'commission',component: () => import('@/page/user/commission'),meta: { title: '佣金记录'}},
			// {title:'资金明细',path: 'br_details',component: () => import('@/page/task/br_details'),meta: { title: '资金明细'}},
	    ]
	},
	{
		title:'个人资料',
	    path: '/user/',
	    component: Layout,
	    meta: { title: '个人资料',icon:"user" },
	    children: [
			{title:'基本信息',path: 'index',component: () => import('@/page/user/index'),meta: { title: '基本信息'}},
			{title:'账户安全',path: 'security',component: () => import('@/page/user/security'),meta: { title: '账户安全'}},
			{title:'站内信',path: 'message',component: () => import('@/page/user/message'),meta: { title: '站内信'}},
	    ]
	},
]
export default new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
})